import styled from 'styled-components';
import React, { FunctionComponent } from 'react';
import { AnamnesisSeverityIcon } from 'components/patient-entry/AnamnesisSeverityIcon';
import { AnamnesisSeverity } from 'ts-types/api.types';
import FinalFormSelect, { FinalFormSelectProps } from 'components/final-form/Select';

const FinalFormSelectWithIcon = styled(FinalFormSelect)`
  &.select-with-icon {
    position: relative;

    .ui.search.dropdown>.text {
      margin-left: 1.175rem;
    }

    .ui.search.dropdown>input.search {
      margin-left: 1.1rem;
    }

    .severity-icon {
      position: absolute;
      top: 0.435rem;
      left: .39rem;
    }
  }
`;

export const AnamnesisSeveritySelect: FunctionComponent<FinalFormSelectProps> = (props) => {

  return <FinalFormSelectWithIcon className={`${props.className} select-with-icon`} {...props}>
    <AnamnesisSeverityIcon severity={props.input.value as AnamnesisSeverity | "any"}/>
  </FinalFormSelectWithIcon>;
};
